<template>
    <div class="lang arabic">
        <div class="process">
            <div class="info on">
                <ul class="step-box">
                    <li class="step-box__item"><span class="step-box__item--step">الخطوة الخامسة</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">الدفع</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">الخطوة الرابعة</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">التشاور مع الطبيب</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">الخطوة الثالثة</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">التسجيل في مكتب الاستقبال</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">الخطوة الثانية</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">استلام المستلزمات واتصل لتأكيد الموعد</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">الخطوة الأولى</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">حدد موعدًا،</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">الخطوة السادسة</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">اجراء الفحص</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">الخطوة السابعة</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">إكمال الفحص، تحديد موعد</h4>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="info">
                <h3 class="bullet01">المواعيد</h3>
                <p class="bullet03 depth">الهاتف: : 82-2-6986-2222~4</p>
                <p class="bullet03 depth">مكتب المعلومات التابع لمركز العافية لتعزيز الصحة، الطابق الثالث، المبنى C، شخصيًا: مستشفى سيول التابع لجامعة إيهوا النسائية،</p>
                <p class="bullet03 depth">عبر الإنترنت: يمكنك تحديد موعد عبر الإنترنت باستخدام الزر السفلي أدناه</p>
                <p class="bullet03 depth">
                    ساعات الاتصال: جميع أيام الأسبوع من 09:00 صباحا حتى 5:00 مساءا (باستثناء أيام السبت والأعياد)،
                    <br>
                    سوف تتلقى مكالمة هاتفية من الممرضة بمجرد الانتهاء من تحديد موعد الفحص.
                    <br>
                    عند تحديد موعد الفحص، يرجى إبلاغنا بالأدوية التي تتناولها مسبقًا.
                </p>
                <div class="botton-wrap mt40">
                    <a href="" class="main-button c-main">المواعيد</a>
                </div>
            </div>
            <div class="info">
                <h3 class="bullet01">استلام المستلزمات واتصل لتأكيد الموعد</h3>
                <p class="bullet03 depth">تسليم معلومات الفحص واستلام المستلزمات بعد تحديد موعد الفحص؛</p>
                <p class="bullet03 depth">سنتصل بك هاتفيا للتأكيد (مكالمة سعيدة) قبل أسبوع من الفحص.</p>
                <p class="bullet03 depth">سيتم إرسال رسالة نصية (SMS) إلى هاتفك الخلوي قبل يوم من الفحص.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">التسجيل في مكتب الاستقبال</h3>
                <p class="bullet03 depth">التحقق من الموعد والتسجيل في مكتب المعلومات من مركز العافية لتعزيز الصحة ،</p>
                <p class="bullet03 depth">تقديم المستلزمات (الاستبيان، عينة البراز، وما إلى ذلك)،</p>
                <p class="bullet03 depth">تعليمات بشأن الاختبارات والإجراءات التي يتعين إجراؤها.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">التشاور مع الطبيب</h3>
                <p class="bullet03 depth">التشاور مع الطبيب واستكمال استمارة الموافقة قبل بدء الفحص الطبي</p>
            </div>
            <div class="info">
                <h3 class="bullet01">الدفع</h3>
                <p class="bullet03 depth">دفع رسوم الفحص الطبي</p>
            </div>
            <div class="info">
                <h3 class="bullet01">اجراء الفحص</h3>
                <p class="bullet03 depth">خلع الملابس وارتداء ملابس الفحص والنعال (إزالة جميع الإكسسوارات، الأشياء الثمينة يمكن الاحتفاظ بها على حده)،</p>
                <p class="bullet03 depth">اجراءات برنامج الفحص الطبي (3 - 6 ساعات حسب الحاجة).</p>
            </div>
            <div class="info">
                <h3 class="bullet01">إكمال الفحص، تحديد موعد</h3>
                <p class="bullet03 depth">يتم إعلام المريض بالاحتياطات الواجب اتخاذها في المنزل (يتم توفير قسيمة الوجبات)</p>
                <p class="bullet03 depth">تحديد موعد لمراجعة النتائج: اختر زيارة للاستشارة أو تسليم بالبريد.</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>